module.exports = __webpack_public_path__ + "media/audio51.01f51376.mp3";